export default {
  root: {
    padding: "4px 9px",
  },
  colorPrimary: {
    color: "#366b92",
  },
};
